import { render, staticRenderFns } from "./stratigraphic.vue?vue&type=template&id=7c2e78f6&scoped=true&"
import script from "./stratigraphic.vue?vue&type=script&lang=js&"
export * from "./stratigraphic.vue?vue&type=script&lang=js&"
import style0 from "./stratigraphic.vue?vue&type=style&index=0&id=7c2e78f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e78f6",
  null
  
)

export default component.exports